<template>
	<div class="row mt-4 hide-on-mobile-inline">
		<p class="f-12 align-self-center margin-0"><strong>Filter</strong>
		</p>
		<div class="form-group col mr-2 ml-4">
			<date-picker 
				v-model="advanceFilter.date_start" 
				placeholder="Pilih tanggal mulai" 
				style="width: 100%;" 
				format="MMMM D, YYYY" 
				value-type="YYYY-MM-DD">
			</date-picker>
		</div>		
		<div class="form-group col mr-2">
			<date-picker 
				v-model="advanceFilter.date_end" 
				placeholder="Pilih tanggal akhir" 
				style="width: 100%;" 
				format="MMMM D, YYYY" 
				value-type="YYYY-MM-DD">
			</date-picker>
		</div>
		<div class="form-group col mr-2">			
			<SelectOption placeholder="Pilih kota asal pengiriman" url="location" label="kabupaten" keyId="id_location" :defaultId="advanceFilter.kota_asal" @setValue="setValueOrigin"/>
		</div>
		<div class="form-group col mr-2">			
			<SelectOption placeholder="Pilih kota tujuan pengiriman" url="location" label="kabupaten" keyId="id_location" :defaultId="advanceFilter.kota_tujuan" @setValue="setValueDestination"/>
		</div>
		<a @click="reset()" class="link align-self-center ml-2 mr-4 f-14" href="">Reset</a>
	</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
	.multiselect__tags {
		font-size: 12px;
	}

	.multiselect__single {
		font-size: 12px;
	}
</style>
<script>
import { EventBus } from '@/plugins/bus.js'
import SelectOption from './SelectOption'

export default {
	name: 'AdvanceFilter',
	components: {		
		SelectOption
	},
	data() {
		return {
			options: [],
			advanceFilter: {
				date_start	: "",
				date_end	: "",
				kota_asal	: "",
				kota_tujuan	: ""
			}			
		}
	},
	methods: {
		reset(){
			let _ = this			

			_.advanceFilter = {
				date_start	: "",
				date_end	: "",
				kota_asal	: "",
				kota_tujuan	: ""
			}
			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		},
		setValueOrigin(val) {
			let _ = this
			_.advanceFilter.kota_asal = val			
			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		},
		setValueDestination(val) {
			let _ = this
			_.advanceFilter.kota_tujuan = val			
			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		}
	},
	watch: {
		'advanceFilter.date_start': function(){
			EventBus.$emit('setAdvanceFilter', this.advanceFilter)
		},
		'advanceFilter.date_end': function(){
			EventBus.$emit('setAdvanceFilter', this.advanceFilter)
		}
	}
}
</script>